import {useCallback,useSyncExternalStore} from 'react';

const prefix='tradelog-preparation-reminder:';
const fallback=new Map(),listeners=new Set();
const key=uid=>`${prefix}${encodeURIComponent(uid)}`;
const notify=()=>listeners.forEach(listener=>listener());
function read(uid){
  if(!uid)return true;
  if(fallback.has(uid))return fallback.get(uid);
  try{const value=localStorage.getItem(key(uid));return value===null?(fallback.get(uid)??true):value!=='hidden';}
  catch{return fallback.get(uid)??true;}
}
function subscribe(listener){
  listeners.add(listener);
  const changed=event=>{if(event.key===null||event.key?.startsWith(prefix)){if(event.key===null)fallback.clear();else{try{fallback.delete(decodeURIComponent(event.key.slice(prefix.length)));}catch{}}notify();}};
  window.addEventListener('storage',changed);
  return()=>{listeners.delete(listener);window.removeEventListener('storage',changed);};
}
export default function usePreparationPreference(uid){
  const snapshot=useCallback(()=>read(uid),[uid]);
  const visible=useSyncExternalStore(subscribe,snapshot,()=>true);
  const setVisible=useCallback(value=>{
    if(!uid)return;
    fallback.set(uid,!!value);
    try{localStorage.setItem(key(uid),value?'visible':'hidden');}catch{}
    notify();
  },[uid]);
  return {visible,setVisible};
}
